var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-10 w-full h-full flex-1 flex flex-col"},[_c('div',{staticClass:"flex w-full flex-1"},[_c('TimetableSplitViewEventList'),_c('TimetableSplitViewTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }